export default {
  title: {
    id: 'review_ai_summary_filters_title',
    defaultMessage: 'Filter by top mentions',
  },
  showMore: {
    id: 'review_ai_summary_filters_show_more',
    defaultMessage: 'Show more',
  },
  showLess: {
    id: 'review_ai_summary_filters_show_less',
    defaultMessage: 'Show less',
  },

  // Tags
  quality: {
    id: 'review_ai_summary_tag_quality',
    defaultMessage: 'Quality',
  },
  condition: {
    id: 'review_ai_summary_tag_condition',
    defaultMessage: 'Condition',
  },
  authenticity: {
    id: 'review_ai_summary_tag_authenticity',
    defaultMessage: 'Authenticity',
  },
  performance: {
    id: 'review_ai_summary_tag_performance',
    defaultMessage: 'Performance',
  },
  battery: {
    id: 'review_ai_summary_tag_battery',
    defaultMessage: 'Battery',
  },
  screen: {
    id: 'review_ai_summary_tag_screen',
    defaultMessage: 'Screen',
  },
  touchscreen: {
    id: 'review_ai_summary_tag_touchscreen',
    defaultMessage: 'Touchscreen',
  },
  design: {
    id: 'review_ai_summary_tag_design',
    defaultMessage: 'Design',
  },
  valueForMoney: {
    id: 'review_ai_summary_tag_value_for_money',
    defaultMessage: 'Value for money',
  },
  delivery: {
    id: 'review_ai_summary_tag_delivery',
    defaultMessage: 'Delivery',
  },
  customerService: {
    id: 'review_ai_summary_tag_customer_service',
    defaultMessage: 'Customer service',
  },
  accessories: {
    id: 'review_ai_summary_tag_accessories',
    defaultMessage: 'Accessories',
  },
  accessoryCompatibility: {
    id: 'review_ai_summary_tag_accessory_compatibility',
    defaultMessage: 'Accessory compatibility',
  },
  camera: {
    id: 'review_ai_summary_tag_camera',
    defaultMessage: 'Camera',
  },
  connectivity: {
    id: 'review_ai_summary_tag_connectivity',
    defaultMessage: 'Connectivity',
  },
  callQuality: {
    id: 'review_ai_summary_tag_call_quality',
    defaultMessage: 'Call quality',
  },
  biometricSecurity: {
    id: 'review_ai_summary_tag_biometric_security',
    defaultMessage: 'Biometric security',
  },
  storageCapacity: {
    id: 'review_ai_summary_tag_storage_capacity',
    defaultMessage: 'Storage capacity',
  },
  unlockedStatus: {
    id: 'review_ai_summary_tag_unlocked_status',
    defaultMessage: 'Unlocked status',
  },
  software: {
    id: 'review_ai_summary_tag_software',
    defaultMessage: 'Software',
  },
  waterResistance: {
    id: 'review_ai_summary_tag_water_resistance',
    defaultMessage: 'Water resistance',
  },
  keyboard: {
    id: 'review_ai_summary_tag_keyboard',
    defaultMessage: 'Keyboard',
  },
  trackpad: {
    id: 'review_ai_summary_tag_trackpad',
    defaultMessage: 'Trackpad',
  },
  ports: {
    id: 'review_ai_summary_tag_ports',
    defaultMessage: 'Ports',
  },
  webcam: {
    id: 'review_ai_summary_tag_webcam',
    defaultMessage: 'Webcam',
  },
  cooling: {
    id: 'review_ai_summary_tag_cooling',
    defaultMessage: 'Cooling',
  },
  noiseLevel: {
    id: 'review_ai_summary_tag_noise_level',
    defaultMessage: 'Noise level',
  },
  audio: {
    id: 'review_ai_summary_tag_audio',
    defaultMessage: 'Audio',
  },
  portability: {
    id: 'review_ai_summary_tag_portability',
    defaultMessage: 'Portability',
  },
  cellularConnectivity: {
    id: 'review_ai_summary_tag_cellular_connectivity',
    defaultMessage: 'Cellular connectivity',
  },
  strapQuality: {
    id: 'review_ai_summary_tag_strap_quality',
    defaultMessage: 'Strap quality',
  },
  fitnessTracking: {
    id: 'review_ai_summary_tag_fitness_tracking',
    defaultMessage: 'Fitness tracking',
  },
  gpsAccuracy: {
    id: 'review_ai_summary_tag_gps_accuracy',
    defaultMessage: 'GPS accuracy',
  },
  notifications: {
    id: 'review_ai_summary_tag_notifications',
    defaultMessage: 'Notifications',
  },
  appCompatibility: {
    id: 'review_ai_summary_tag_app_compatibility',
    defaultMessage: 'App compatibility',
  },
  fit: {
    id: 'review_ai_summary_tag_fit',
    defaultMessage: 'Fit',
  },
  protection: {
    id: 'review_ai_summary_tag_protection',
    defaultMessage: 'Protection',
  },
  materialQuality: {
    id: 'review_ai_summary_tag_material_quality',
    defaultMessage: 'Material quality',
  },
  buttonAccess: {
    id: 'review_ai_summary_tag_button_access',
    defaultMessage: 'Button access',
  },
  transparency: {
    id: 'review_ai_summary_tag_transparency',
    defaultMessage: 'Transparency',
  },
  upgradability: {
    id: 'review_ai_summary_tag_upgradability',
    defaultMessage: 'Upgradability',
  },
  easeOfUse: {
    id: 'review_ai_summary_tag_ease_of_use',
    defaultMessage: 'Ease of use',
  },
  capacity: {
    id: 'review_ai_summary_tag_capacity',
    defaultMessage: 'Capacity',
  },
  energyEfficiency: {
    id: 'review_ai_summary_tag_energy_efficiency',
    defaultMessage: 'Energy efficiency',
  },
} as const
